// extracted by mini-css-extract-plugin
export default {"container":"_1HJiUF","contentWrapper":"_3jsbDP"};